const SvgIcon = ({size = '24', active = false, color = '#000', fill = '#444247' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 25 25"
  >
    {active === true &&
      <>
        <circle
          cx="12.5"
          cy="12.5"
          r="12"
          fill='#000'
          stroke='#fff'
          strokeWidth="1"
        ></circle>
        <path
          fill={color}
          strokeWidth="1"
          d="M10.362 13.158v6.4H8.264V5.185h2.07v5.349h.134a3.1 3.1 0 0 1 1.158-1.383q.78-.512 2.035-.512 1.11 0 1.937.456.836.456 1.292 1.362.463.897.463 2.246v6.857h-2.099v-6.605q0-1.186-.61-1.839-.611-.66-1.699-.66-.744 0-1.333.316-.583.316-.92.927-.33.603-.33 1.46"
        ></path>
      </>
    }
    {active !== true &&
      <path
        fill={color}
        fillOpacity="0.98"
        strokeWidth="1"
        d="M10.362 13.158v6.4H8.264V5.185h2.07v5.349h.134a3.1 3.1 0 0 1 1.158-1.383q.78-.512 2.035-.512 1.11 0 1.937.456.836.456 1.292 1.362.463.897.463 2.246v6.857h-2.099v-6.605q0-1.186-.61-1.839-.611-.66-1.699-.66-.744 0-1.333.316-.583.316-.92.927-.33.603-.33 1.46"
      ></path>
    }
  </svg>
);

export default SvgIcon;
